import coin from './coin'
import task from './task'
import asset from './asset'
export default {
  myAsset: asset,
  coin,
  task,
  success: 'Success'
}
